import { DEFAULT_API_URL, fetchWithAuth } from "./const.routes.ts";
import { PUBLIC_VAPID_KEY } from "../const/enviroment.ts";

export async function subscribeChat() {
  if ("serviceWorker" in navigator) {
    try {
      if (!("Notification" in window)) {
        console.error("Notifications are not supported.");
        return false;
      }

      const permission =
        Notification.permission === "granted"
          ? "granted"
          : await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("Notification permission not granted:", permission);
        return false;
      }

      await navigator.serviceWorker.register("/service-worker.js", {
        scope: "/",
      });
      const registration = await navigator.serviceWorker.ready;

      let subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
        });
      } else {
        return;
      }

      await fetchWithAuth(DEFAULT_API_URL + `/subscribe`, {
        method: "POST",
        body: JSON.stringify(subscription),
      });
      return true;
    } catch (e) {
      if (e instanceof DOMException) {
        console.error("name:", e.name, "message:", e.message, "code:", e.code);
        return false;
      }
      console.error(e);
      return false;
    }
  } else {
    console.error("Service workers are not supported.");
    return false;
  }
}

export async function unsubscribeChat() {
  if ("serviceWorker" in navigator) {
    try {
      if (!("Notification" in window)) {
        console.error("Notifications are not supported.");
        return false;
      }

      await navigator.serviceWorker.register("/service-worker.js", {
        scope: "/",
      });
      const registration = await navigator.serviceWorker.ready;

      const subscription = await registration.pushManager.getSubscription();
      if (!subscription) {
        return;
      }
      await fetchWithAuth(DEFAULT_API_URL + `/subscribe/close`, {
        method: "POST",
        body: JSON.stringify(subscription),
      });

      await subscription.unsubscribe();
      return true;
    } catch (e) {
      if (e instanceof DOMException) {
        console.error("name:", e.name, "message:", e.message, "code:", e.code);
        return false;
      }
      console.error(e);
      return false;
    }
  } else {
    console.error("Service workers are not supported.");
    return false;
  }
}

export async function subscribeState() {
  if ("serviceWorker" in navigator) {
    try {
      if (!("Notification" in window)) {
        console.error("Notifications are not supported.");
        return "unsupported";
      }

      await navigator.serviceWorker.register("/service-worker.js", {
        scope: "/",
      });
      const registration = await navigator.serviceWorker.ready;

      const subscription = await registration.pushManager.getSubscription();
      return !!subscription;
    } catch (e) {
      if (e instanceof DOMException) {
        console.error("name:", e.name, "message:", e.message, "code:", e.code);
        return false;
      }
      console.error(e);
      return false;
    }
  } else {
    console.error("Service workers are not supported.");
    return false;
  }
}

// utils.ts
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
